import type { ChannelSummaryType } from 'ChannelSummary/types'
import classNames from 'classnames'
import { selectData } from 'data/selectors'
import React from 'react'
import { useSelector } from 'react-redux'
import type { State } from 'store/types'

import Box from '@mui/material/Box'

import useStyles from './useStyles'

export interface ReplenishmentDetailsProps {
  channel?: string
  countryId?: string
  type: ChannelSummaryType
}

export function ReplenishmentDetails({ channel, countryId, type }: ReplenishmentDetailsProps) {
  const replenishmentVisibility = useSelector((state: State) => state.user.settings.replenishmentVisibility)
  const { data } = useSelector(selectData({ channel, countryId, type }))
  const classes = useStyles()

  if (replenishmentVisibility && !data.replenishmentOnHandShoesCurrent && !data.replenishmentTargetShoesCurrent) {
    return null
  }

  return (
    <Box alignItems="center" display="flex">
      <Box className={classNames('fm fm-replenishment', classes.icon)} mr={1} />
      <div className={classes.valueHigher}>{Math.round((data.replenishmentOnHandShoesCurrent || 0) * 100)}%</div>
      <Box className={classNames('fm fm-future-replenishment', classes.icon)} ml={4} mr={1} />
      <div className={classes.valueHigher}>{Math.round((data.replenishmentTargetShoesCurrent || 0) * 100)}%</div>
    </Box>
  )
}
